import createEvaluationsHook from './createEvaluationsHook';

export default createEvaluationsHook('evaluationProjectPartner', 'project', { completed: true });
